import axios from 'axios';
export const portalApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/portal`, withCredentials: true, timeout: 30000 });
export const setCsrf = token => {
  if (token) portalApi.defaults.headers.common['X-CSRF-Token'] = token;
  else delete portalApi.defaults.headers.common['X-CSRF-Token'];
};
export const errorMessage = error => {
  const detail = error.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail[0]?.msg?.replace(/^Value error, /, '') || 'Check the information and try again.';
  return 'The request could not be completed. Please try again.';
};
export const downloadDocument = async document => {
  const response = await portalApi.get(`/documents/${document.id}/download`, { responseType: 'blob', timeout: 120000 });
  const url = URL.createObjectURL(response.data);
  const link = window.document.createElement('a'); link.href = url; link.download = document.original_filename;
  window.document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};